import { AfterViewInit, Component, Inject, TemplateRef, ViewChild } from '@angular/core';
import { Alert, AlertService, MbsPopupType, MbsSize, ModalService } from 'mbs-ui-kit';
import { Balance } from 'mbs-ui-shared@components/components/models/license.model';
import { RenewLicenseModalComponent } from 'mbs-ui-shared@components/licenses/components/renew-license-modal/renew-license-modal.component';
import { BALANCE_TOKEN } from 'mbs-ui-shared@components/licenses/tokens/balance.token';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { LicensesService } from 'mbs-ui-shared@services';
import { Observable, filter, map, noop } from 'rxjs';

@Component({
  selector: 'mbs-auto-renewal-alert',
  templateUrl: './auto-renewal-alert.component.html'
})
export class AutoRenewalAlertComponent implements AfterViewInit {
  @ViewChild('autoRenewalFailedAlert', { static: true }) autoRenewalFailedAlert: TemplateRef<any>;

  public subscriptionEditLink = this.licensesService.getSubscriptionEditLink();

  public get subscribeUrl(): string {
    return this.authService.subscriptionUrl;
  }

  public get isAutoPay(): Observable<boolean> {
    return this.balance.pipe(
      filter(Boolean),
      map((balance) => balance?.subscriptionEnabled)
    );
  }

  constructor(
    private modalService: ModalService,
    private authService: AuthFacade,
    private alertService: AlertService,
    private licensesService: LicensesService,
    @Inject(BALANCE_TOKEN) public balance: Observable<Balance>
  ) {}

  ngAfterViewInit() {
    const alert = new Alert({
      id: 'auto-renewal-alert',
      icon: true,
      content: this.autoRenewalFailedAlert,
      type: MbsPopupType.danger
    });

    this.alertService.alert(alert);
  }

  public openRenewModal() {
    this.modalService
      .openCustom(RenewLicenseModalComponent, {
        size: MbsSize.xl
      })
      .catch(noop);
  }
}
